// tslint:disable:object-literal-sort-keys
export const Elevation = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4
};
